import { Helpers } from '../../helpers';
import { IOperatingUnit } from '../../interfaces/ioperating-unit';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';

export class OperatingUnitBase {
  OperatingUnitId: number;
  Description: string;
  Acronym: string | null;
  SortOrder: number | null;
  ImageName: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Projects_OperatingUnit?: Array<Project> | null;
  ProjectTemplates_OperatingUnit?: Array<ProjectTemplate> | null;

  constructor(item?: IOperatingUnit) {
    if (item) {

      this.OperatingUnitId = item.OperatingUnitId;
      this.Description = item.Description;
      this.Acronym = item.Acronym;
      this.SortOrder = item.SortOrder;
      this.ImageName = item.ImageName;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Projects_OperatingUnit = Helpers.createClassArray(Project, item.Projects_OperatingUnit);
      this.ProjectTemplates_OperatingUnit = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_OperatingUnit);
    }
  }
}